module.exports = __webpack_public_path__ + "img/background-tv-final.27e2d126.png";